/* eslint-disable react/react-in-jsx-scope */
import { getCurrentBreadCrumbs } from '@/utils';

const initState = () => {
  return {
    breadcrumb: [], // 面包屑
    isUpdate: false, // 设置return null 清除缓存
  };
};

export default {
  namespace: 'subDept',

  state: initState(),

  subscriptions: {
    setup({ dispatch, history }) {
      // 当url参数变化的时候 清除一次缓存
      history.listen(({ pathname, query }) => {
        if (pathname.match(/^\/contacts\/subDept$/)) {
          dispatch({
            type: 'save',
            payload: {
              isUpdate: true,
            },
          });

          setTimeout(() => {
            dispatch({
              type: 'save',
              payload: {
                isUpdate: false,
                breadcrumb: getCurrentBreadCrumbs({
                  currentUrl: {
                    context: query.currentDeptName,
                    path: `/contacts/subDept${window.location.search}`,
                  },
                  storekey: 'managementCenterBreadcrumb',
                }),
              },
            });
          }, 200);
        }
      });
    },
  },

  effects: {},

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
